
import * as umbracoImageProcessorRuntime$zmAt7w7tJA from '/app/solution/node_modules/@limbo-works/image/providers/umbraco-image-processor.js'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536,
    "<568": 567,
    "<605": 604,
    "<760": 759,
    "<990": 989
  },
  "presets": {},
  "provider": "umbracoImageProcessor",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['umbracoImageProcessor']: { provider: umbracoImageProcessorRuntime$zmAt7w7tJA, defaults: undefined }
}
        